import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import InputsFromRepair41_3aTable from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const InputsFromRepair41_3a = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("INPUTS_FROM_REPAIR") || "Inputs from repair"}
        subDescription={t("INPUTS_FROM_REPAIR_41_3A_DESC") || "These are the replacement parts, materials, and energy required to fix a malfunctioning or damaged component. They restore the product to proper functioning and extend its life."}
        isNormal={true}
        number={"41.3a"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`inputs-from-repair-41-3a-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <InputsFromRepair41_3aTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default InputsFromRepair41_3a;

